import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from './translations';
import { extra } from './translationsExtra';

export const LANGUAGES = [
  { code: 'fr', label: 'Français', short: 'FR', flag: '🇫🇷' },
  { code: 'en', label: 'English', short: 'EN', flag: '🇬🇧' },
  { code: 'es', label: 'Español', short: 'ES', flag: '🇪🇸' },
];

function deepMerge(a, b) {
  const out = { ...a };
  for (const k in b) {
    if (b[k] && typeof b[k] === 'object' && !Array.isArray(b[k]) && a && a[k]) out[k] = deepMerge(a[k], b[k]);
    else out[k] = b[k];
  }
  return out;
}

const merged = {
  fr: deepMerge(translations.fr, extra.fr),
  en: deepMerge(translations.en, extra.en),
  es: deepMerge(translations.es, extra.es),
};

const detect = () => {
  try { const s = localStorage.getItem('hitmax_lang'); if (s && merged[s]) return s; } catch (e) {}
  try { const n = (navigator.language || 'fr').slice(0, 2); if (merged[n]) return n; } catch (e) {}
  return 'fr';
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detect);
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem('hitmax_lang', l); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('hitmax-lang', { detail: l })); } catch (e) {}
  };
  useEffect(() => {
    try { localStorage.setItem('hitmax_lang', lang); } catch (e) {}
    const h = (e) => setLangState(e.detail);
    window.addEventListener('hitmax-lang', h);
    return () => window.removeEventListener('hitmax-lang', h);
  }, []); // eslint-disable-line
  const t = merged[lang] || merged.fr;
  return <I18nCtx.Provider value={{ t, lang, setLang }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx) || { t: merged.fr, lang: 'fr', setLang: () => {} };

export default LANGUAGES;
